/**
 * Delete Confirmation Modal Component
 */
import { X, Trash2 } from "lucide-react";

export const DeleteConfirmModal = ({
  show,
  onClose,
  title,
  message,
  onConfirm,
  deleting
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-white rounded-xl w-full max-w-md p-6 animate-fadeIn">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Trash2 size={20} className="text-red-500" />
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X size={20} className="text-gray-500" />
          </button>
        </div>
        
        <p className="text-gray-600 mb-6">{message}</p>
        
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 px-4 border border-gray-200 rounded-xl text-gray-700 font-medium hover:bg-gray-50"
          >
            Odustani
          </button>
          <button
            onClick={onConfirm}
            disabled={deleting}
            className="flex-1 py-3 px-4 bg-red-500 text-white rounded-xl font-medium hover:bg-red-600 disabled:opacity-50"
          >
            {deleting ? "Brišem..." : "Obriši"}
          </button>
        </div>
      </div>
    </div>
  );
};
